
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllocatorProfileShowPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminFunds"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employerProfile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alreadyRequestedIntro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allocatorProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introRequestPeriodEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introRequestsLeft"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAllocatorBlocklisted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allocatorProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAllocator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAllocatorAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allocatorProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}}}],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allocatorProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allocatorProfileId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileBackgroundImage"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileCard"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileExecutiveManagement"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileInvestmentPreferences"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocatorRecommendation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocatorProfileRecommendation"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"investmentCriteria"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recentlyJoined"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1219}};
    doc.loc.source = {"body":"#import '../fragments/AllocatorProfileBackgroundImage.graphql'\n#import '../fragments/AllocatorProfileCard.graphql'\n#import '../fragments/AllocatorProfileSection/AllocatorProfileExecutiveManagement.graphql'\n#import '../fragments/AllocatorProfileSection/AllocatorProfileInvestmentPreferences.graphql'\n#import '../fragments/AllocatorProfileRecommendation.graphql'\n\nquery AllocatorProfileShowPage($allocatorProfileId: ID!) {\n  currentUser {\n    id\n    adminFunds {\n      id\n      primary\n      employer {\n        id\n        employerProfile {\n          id\n          alreadyRequestedIntro(allocatorProfileId: $allocatorProfileId)\n          introRequestPeriodEnd\n          introRequestsLeft\n          isAllocatorBlocklisted(allocatorProfileId: $allocatorProfileId)\n          status\n        }\n        name\n      }\n    }\n    isAllocator\n    isAllocatorAdmin(allocatorProfileId: $allocatorProfileId)\n  }\n  allocatorProfile(id: $allocatorProfileId) {\n    ...AllocatorProfileBackgroundImage\n    ...AllocatorProfileCard\n    ...AllocatorProfileExecutiveManagement\n    ...AllocatorProfileInvestmentPreferences\n    allocatorRecommendation {\n      ...AllocatorProfileRecommendation\n    }\n    investmentCriteria\n    recentlyJoined\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileBackgroundImage.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileCard.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileSection/AllocatorProfileExecutiveManagement.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileSection/AllocatorProfileInvestmentPreferences.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/AllocatorProfileRecommendation.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AllocatorProfileShowPage"] = oneQuery(doc, "AllocatorProfileShowPage");
        
